import React from 'react';
import {Avatar, Space, Tag} from "antd";
import Table from "../../../../componets/Table";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { ColumnsType } from "antd/es/table";
import { ButtonEdit } from "../../../../componets/Buttons";
import { setEditId, BundleInterface } from "../../../../store/mine_craft/bundlesSlice";
import { EntityId } from "@reduxjs/toolkit";
import { formattedDate } from "../../../../helpers/DateHelpers";
import OptionalLink from "../../../../componets/OptionalLink";
import Pagination from "../../../../componets/Pagination";
import usePermissions from "../../../../hooks/usePermissions";
import {AppleOutlined} from "@ant-design/icons";

interface ListTableInterface {
  className?: string;
  limit: number;
}

const _ListTable = ({ className, limit }: ListTableInterface) => {
  const dispatch  = useAppDispatch();
  const ids       = useAppSelector(state => state.mineCraft.bundles.ids);
  const bundles   = useAppSelector(state => state.mineCraft.bundles.entities);
  const count     = useAppSelector(state => state.mineCraft.bundles.count);
  const { write_minecraft } = usePermissions();
  const data      = ids ? ids.map(id => bundles[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  const renderCertLabel = (push_cert_url: string | undefined) => {
    if (push_cert_url) {
      return <Tag color="success">true</Tag>
    } else {
      return <Tag color="default">false</Tag>
    }
  }

  const renderNotifyLabel = (notify: boolean) => {
    if (notify) {
      return <Tag color="success">enabled</Tag>
    } else {
      return <Tag color="default">disabled</Tag>
    }
  }

  const renderEnvLabel = (prod: boolean) => {
    if (prod) {
      return <Tag color="success">production</Tag>
    } else {
      return <Tag color="default">development</Tag>
    }
  }

  const columns: ColumnsType<BundleInterface> = [
    {
      key: 'thumbnail_url',
      title: '',
      dataIndex: 'thumbnail_url',
      render: (_, { thumbnail_url }) => {
        return <Avatar
          src={thumbnail_url}
          alt='Bundle icon'
          size={32}
          icon={<AppleOutlined />}
          shape='square'
        />
      },
      width: 50
    },

    {
      key: 'name',
      title: 'Name',
      render: (_, { name, url }) => <OptionalLink link={url}>{name}</OptionalLink>,
      width: 135,
      ellipsis: true
    },

    {
      key: 'version',
      title: 'Version',
      render: (_, { version, url }) => <small>v.{version || '-'}</small>,
      width: 70,
      ellipsis: true
    },

    {
      key: 'push_cert_url',
      title: 'Push Cert',
      render: (_, { push_cert_url }) => renderCertLabel(push_cert_url),
      width: 80
    },

    {
      key: 'notification',
      title: 'Notification',
      render: (_, { notification }) => renderNotifyLabel(notification),
      width: 125
    },

    {
      key: 'prod',
      title: 'Environment',
      render: (_, { prod }) => renderEnvLabel(prod),
      width: 125
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => {
        return <small>{formattedDate(created_at).dateTime}</small>;
      },
      width: 125
    },

    {
      key: 'updated_at',
      title: 'Updated at',
      render: (_, { updated_at }) => {
        return <small>{formattedDate(updated_at).dateTime}</small>;
      },
      width: 125
    },

    ...(write_minecraft ? [{
      key: 'action',
      title: 'Action',
      render: (_: any, { id}: BundleInterface) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
          </Space>
        );
      },
      width: 100
    }] : []),
  ];

  return (
    <div className={className}>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
      />

      <Pagination className='v-mt-10' total={count} size={limit} />
    </div>
  )
}

export default _ListTable;
